import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Modal, ModalBody, Button, Form, Label, Col, Row, Alert } from 'reactstrap';
import './RemoveCertificateModal.css';
import _ from 'lodash';
import { sharedLabelsPath } from "../../../../reducers/common/localization";
import moment from 'moment';

class RemoveCertificateModal extends Component {
    render() {
        if (!_.isNil(this.props.certificate)) {
            return (
                <Modal isOpen={this.props.isOpen} toggle={this.props.onCancel}>
                    <ModalBody>
                        <div className='remove-certificate-container'>
                            <Form>
                                <Alert color="danger">{_.get(this.props.translation, 'certificate.remove_warning_label')}</Alert>
                                <Label>
                                    {_.get(this.props.translation, 'certificate.are_you_sure_label')}
                                </Label>
                                <Row className="modal-form-field-container">
                                    <Col sm={5}>
                                        {_.get(this.props.translation, 'certificate.valid_till_label') + ":"}
                                    </Col>
                                    <Col>
                                        {moment(this.props.certificate.createdAt).format("MMMM Do YYYY, HH:mm")}
                                    </Col>
                                </Row>
                                <Row className="modal-form-field-container">
                                    <Col sm={5}>
                                        {_.get(this.props.translation, 'certificate.valid_from_label') + ":"}
                                    </Col>
                                    <Col>
                                        {moment(this.props.certificate.validFrom).format("MMMM Do YYYY, HH:mm")}
                                    </Col>
                                </Row>
                                <Row className="modal-form-field-container">
                                    <Col sm={5}>
                                        {_.get(this.props.translation, 'certificate.valid_till_label') + ":"}
                                    </Col>
                                    <Col>
                                        {moment(this.props.certificate.validTill).format("MMMM Do YYYY, HH:mm")}
                                    </Col>
                                </Row>
                                <div className="remove-certificate-buttons-container">
                                    <Button color='secondary' onClick={this.props.onCancel}>
                                        {_.get(this.props.translation, sharedLabelsPath.cancel_button)}
                                    </Button>
                                    <Button
                                        className="olive-green-btn"
                                        onClick={this.onRemoveCertificate}
                                    >
                                        {_.get(this.props.translation, 'certificate.remove_button')}
                                    </Button>
                                </div>
                            </Form>
                        </div>
                    </ModalBody>
                </Modal>
            );
        } else {
            return null;
        }
    }

    onRemoveCertificate = () => {
        this.props.onRemoveCertificate(this.props.certificate.id, this.props.orgId || null);
    };
}

RemoveCertificateModal.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    certificate: PropTypes.object,
    certId: PropTypes.string,
    orgId: PropTypes.string,
    translation: PropTypes.object.isRequired,
    onRemoveCertificate: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired
};

export default RemoveCertificateModal;



// WEBPACK FOOTER //
// ./src/components/organizationManagement/certificatesManagement/removeCertificateModal/RemoveCertificateModal.js